import http from "../http-common";

class EmailService {
  sendEmail(data) {
    return http.post("/mail.php", data);
  }
}

export default new EmailService();